import React, { Fragment } from 'react';
import { Segment, Icon, Button } from "semantic-ui-react"

const pStyle = {
    paddingTop: '7px',

};

const h2Style = {
    fontSize: '1rem',
    paddingLeft: "5px"

};
const subh2Style = {
    paddingRight: "6px",
    display: "inline-block"
}

const deptCheck = (props) => {
    return (
        <>
            Dept: {props.userObject.department}
        </>
    )
}
const Heading = (props) => {
    if (!props.url.id)
        return <h3>Add New User</h3>
    else {
        return (
            <>
                <h3><span className="mainheading_ellipse">{props.userObject.user_name}</span> <Icon name='circle' size='tiny' className="j_mini_circle j_minitop_circle" /> <span style={h2Style}>{props.userObject.email_id}</span></h3>
                <h5 className="j_normalheader"><div style={subh2Style}>Dept:&nbsp;<span className="subheading_ellipse"><span className="j_spanboldheader">{props.userObject.department ? props.userObject.department.join(",") : ""}</span></span></div><div style={subh2Style}><Icon name='circle' size='mini' className="j_mini_circle" />&nbsp;&nbsp;Primary Location:&nbsp;<span className="j_spanboldheader">{props.userObject.location}</span></div><div style={subh2Style}><Icon name='circle' size='mini' className="j_mini_circle" />&nbsp;&nbsp;Primary Role:&nbsp;<span className="j_spanboldheader">{props.userObject.primary_role != "undefined" ? props.userObject.primary_role : ""}</span></div></h5>
            </>
        )
    }
}

const ActionButton = (props) => {
    if (!props.url.id) {
        return (
            <div className="ui horizontal list">
                <button className="ui small inverted white button" disabled={!props.userObject.disable_save} onClick={(e) => props.userObject.cancelUser(e)}>Cancel</button>
                <button className="ui small button secondary normal" disabled={!props.userObject.disable_save || props.userObject.request_status} onClick={(e) => props.userObject.addUser(e)}>Add User</button>
                <a onClick={() => props.userObject.closeProfile()}>  <Button basic secondary icon className="border-0 only-icon ml-12"> <Icon name="cancel" className="xcm-icon-close size-20" /> </Button> </a>
            </div>
        );
    }
    else {
        return (
            <div className="ui horizontal list" style={pStyle}>
                <button className="ui small inverted white button" disabled={!props.userObject.disable_save} onClick={(e) => props.userObject.discardUser(e)}>Cancel</button>
                <button className="ui small button secondary normal" disabled={!props.userObject.disable_save || props.userObject.request_status} onClick={(e) => props.userObject.saveUser(e)}>Save Changes</button>
                <a onClick={() => props.userObject.closeProfile()}>    <Button basic secondary icon className="border-0 only-icon ml-12"> <Icon name="cancel" className="xcm-icon-close size-20" /> </Button> </a>
            </div>
        );
    }
}
const User_Header = (props) => {
    //console.log("Header Module");
    return (
        <Segment inverted size="small" className="fixedheader">
            <div className="ui two column grid">
                <div className="twelve wide column">
                    <Heading {...props}></Heading>
                </div>
                <div className="right floated right aligned four wide column">

                    <ActionButton {...props}></ActionButton>
                </div>
            </div>
        </Segment>
    );
}
export default User_Header;